/* eslint-disable no-return-assign */
/* eslint-disable spaced-comment */
/* eslint-disable max-classes-per-file */
/* eslint-disable no-var */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
import { LiteralObject } from 'viggo-sistemas-core-web';

class TipoPerfil {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'ATACADO') {
      this.result = 'ATACADO';
    } else if (enumValue === 'VAREJO') {
      this.result = 'VAREJO';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

export class ValidadorSettingsApplication {
  tipo_perfil = null;
  usa_integracao = false;

  constructor(public application_settings: LiteralObject) {
    const application_regras = application_settings['regras'] ?? {};

    this.tipo_perfil = this.getTipoPerfil(application_regras);
    this.usa_integracao = application_regras['usa_integracao'] ?? false;
  }

  getTipoPerfil(settings) {
    var op = settings['tipo_perfil'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoPerfil(op).result;
  }

  getApplicationSettingsBody(application_settings) {
    return (application_settings = {
      regras: {
        tipo_perfil: this.tipo_perfil,
        usa_integracao: this.usa_integracao
      }
    });
  }
}
